import { HttpClient, HttpParams, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { AccountInfo } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  account: AccountInfo | undefined;

  constructor(
    private readonly http: HttpClient,
    private readonly authService: MsalService,
    private readonly router: Router,
  ) {
    this.account = this.authService.instance.getAllAccounts()[0];
  }

  findAllMenu(): Observable<any> {
    const id = this.account ? this.account?.localAccountId : '1';

    return this.http.get(`${environment.menuBackend}` + id).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        console.log(error);
        if (error?.status !== HttpStatusCode.Unauthorized) {
          this.router.navigate(['./not-user-found']);
        }
        return throwError(() => error);
      }),
    );
  }

  findAllMenuByUser(): Observable<any> {
    const id = this.account ? this.account?.localAccountId : '1';

    return this.http.get(`${environment.menuNewBackend}` + id).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        if (error?.status !== HttpStatusCode.Unauthorized) {
          this.router.navigate(['./not-user-found']);
        }
        return throwError(() => error);
      }),
    );
  }

  findAllMenusList(
    page?: number,
    limit?: number,
    name?: string,
  ): Observable<any> {
    let params = new HttpParams();
    params = params.set('name', name ?? '');
    params = params.set('limit', limit ?? '');
    params = params.set('page', page ?? '');
    params = params.set('sortBy', 'position');

    return this.http.get(`${environment.menusBOBackend}s`, { params }).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        console.log(error);
        return throwError(() => error);
      }),
    );
  }

  editMenus(user: any, id: any) {
    const { userId, ...rest } = user;

    return this.http
      .put(`${environment.menusBOBackend}/${id}`, rest, {
        headers: { 'X-User-Id': userId },
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error: any) => {
          console.log(error);
          return throwError(() => error);
        }),
      );
  }

  saveMenus(user: any) {
    const { userId, ...rest } = user;
    console.log({ user });
    return this.http
      .post(`${environment.menusBOBackend}`, rest, {
        headers: { 'X-User-Id': userId },
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error: any) => {
          console.log(error);
          return throwError(() => error);
        }),
      );
  }
}
